import React from "react";
import { Dialog, DialogContent, Box, Slide } from "@material-ui/core";
import Loading from "./loading";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function UnstakeModal({ open, setOpen, unstakeHandler, loading }) {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <div className="modal__main__container">
        <Dialog
          open={open}
          keepMounted
          TransitionComponent={Transition}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent
            className="dialoge__content__section"
            style={{
              background: "#727272",
              boxShadow: "0px 0px 13px rgba(182, 0, 211, 0.7)",
            }}
          >
            <Loading loading={loading} />

            <Box component="h3" fontSize="30px">
              <span style={{ color: "red" }}> Warning!</span> You will not
              receive any reward.
            </Box>
            <Box
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              p={1}
            >
              <Box onClick={handleClose}>
                <button
                  style={{
                    background: "#E51F34",
                    borderRadius: "14px",
                    color: "white",
                    padding: "10px 40px",
                    fontSize: "18px",
                    border: "none",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </Box>
              <Box>
                <button
                  style={{
                    background: "#E51F34",
                    borderRadius: "14px",
                    color: "white",
                    padding: "10px 40px",
                    fontSize: "18px",
                    border: "none",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={unstakeHandler}
                >
                  UnStake
                </button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        {/* </Slide> */}
      </div>
    </div>
  );
}

export default UnstakeModal;
